import { ReactElement } from "react";
import { Spin } from 'antd';

export default function Loading(): ReactElement {
  return (
    <div className="loading-container">
      <Spin />
    </div>
  );
}
